import ajax from '@/libs/api.request'
export default {
  getCateList:param=>{
    return ajax.get('edu/web/course/getCateList');
  },
  saveCate:param=>{
    return ajax.post('edu/web/course/saveCate',param);
  },
  delCate:param=>{
    return ajax.post('edu/web/course/delCate',param);
  },
  getCourseList:param=>{
    return ajax.post('edu/web/course/getCourseList',param);
  },
  saveCourse:param=>{
    return ajax.post('edu/web/course/saveCourse',param);
  },
  delCourse:param=>{
    return ajax.post('edu/web/course/delCourse',param);
  },
  getCourseDetail:param=>{
    return ajax.post('edu/web/course/getCourseDetail',param);
  },
  getAllClass:param=>{
    return ajax.post('edu/web/course/getAllClass',param);
  },
  cancleClassBatch:param=>{
    return ajax.post('edu/web/course/cancleClassBatch',param);
  },
  cancleClass:param=>{
    return ajax.post('edu/web/course/cancleClass',param);
  },
  cancleByTime:param=>{
    return ajax.post('edu/web/course/cancleByTime',param);
  },
  getAllSchedule:param=>{
    return ajax.post('edu/web/course/getAllSchedule',param);
  },
  getAllScheduleWeek:param=>{
    return ajax.get('edu/web/course/getAllScheduleWeek');
  },
  cancleScheduleclass:param=>{
    return ajax.post('edu/web/course/cancleScheduleclass',param);
  }
}
